/**
 * @alias ConsoleMessages
 * @type {object}
 * @memberof module:Config/ConsoleMessages
 */
export default {
    items: 'The items property must be an array.',
    theme: 'The theme property must be an object.',
    language: 'The language must be an object.',
    date: 'The value must be an instance of a Date.',
    face: 'The face must be an instance of a Face class.',
    element: 'The element must be an instance of an HTMLElement',
    faceValue: 'The face must be an instance of a FaceValue class.',
    timer: 'The timer property must be an instance of a Timer class.'
};
